import { useMoviesStore } from "@multicines/stores";
import { Clickable } from "artisn-ui-react";
import React from "react";

import Styles from "./CorporateTicketInfo.styles";
import { CorporateTicketInfoProps as Props } from "./CorporateTicketInfo.types";
import useI18n from "hooks/useI18n";
import useUtils from "hooks/useUtils";

import CloseSVG from "../../../../public/assets/images/close.svg";
import TicketSVG from "../../../../public/assets/images/ticket.svg";

const CorporateTicketInfo: React.FC<Props> = props => {
  const { netPrice = 0, handleDismissTicket, name = "" } = props;
  const { ticketsQuantity = 1 } = props;
  const selectedSession = useMoviesStore(store => store.selectedSession);
  const t = useI18n();
  const { formatByCurrency } = useUtils();

  const { sessionAttributesNames } = selectedSession ?? {};
  const [sessionAttribute] = sessionAttributesNames ?? [];

  return (
    <Styles className="CorporateTicketInfo">
      <div className="CorporateTicketInfo__content">
        <div className="CorporateTicketInfo__tags">
          <p className="CorporateTicketInfo__tag CorporateTicketInfo__tag--principal">
            <TicketSVG className="CorporateTicketInfo__svg" />
            {t.seats.SeatsCategory.tickets}
          </p>
          {sessionAttribute ? (
            <p className="CorporateTicketInfo__tag">{sessionAttribute}</p>
          ) : null}
        </div>

        <h1 className="CorporateTicketInfo__title-card">{name}</h1>

        <div>
          <p className="CorporateTicketInfo__price">
            {formatByCurrency(netPrice)}
          </p>
          <p className="CorporateTicketInfo__info">
            {t.common.applyFor}
            {ticketsQuantity} {t.common.person}
            {ticketsQuantity > 1 ? "s" : ""}
          </p>
        </div>
      </div>
      <Clickable
        className="CorporateTicketInfo__close"
        onClick={handleDismissTicket}
      >
        <CloseSVG />
      </Clickable>
    </Styles>
  );
};

export default CorporateTicketInfo;
